import Swiper from "swiper";
import { Navigation } from "swiper/modules";

class ReviewsSlider {
  constructor() {
    this.sliderInit();
    this.readMoreInit();
  }

  sliderInit = () => {
    const slider = new Swiper(".js-reviews-slider", {
      modules: [Navigation],
      spaceBetween: 32,
      slidesPerView: "auto",
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: ".js-reviews-slider-next",
        prevEl: ".js-reviews-slider-prev",
      },
    });
  };

  readMoreInit = () => {
    const items = document.querySelectorAll(".reviews-item");
    items.forEach((item) => {
      const textEl = item.querySelector(".review-text");
      const btn = item.querySelector(".read-more-btn");

      // Only show the button if text is taller than max-height
      if (textEl.scrollHeight > textEl.clientHeight) {
        btn.style.display = "block";
        btn.addEventListener("click", function () {
          textEl.classList.toggle("expanded");
          this.textContent = textEl.classList.contains("expanded")
            ? "Vidi manje"
            : "Vidi više";
        });
      }
    });
  };
}
export default ProductSlider;

new ReviewsSlider();
